<form class="sub-search" fxFlexFill (ngSubmit)="searchSubscribers()" #searchForm="ngForm" fxFlexLayout="column">
  <div fxFlexFill class="input-group mb-3">
    <div class="input-container">
      <input
        [(ngModel)]="queryString"
        type="text"
        [class]="inputClass()"
        [placeholder]="textboxPlaceholder"
        [attr.aria-label]="textboxPlaceholder"
        aria-describedby="search"
        name="search"
      />
      <span class="k-icon" title="Clear search" *ngIf="showClearButton && queryString" (click)="clear()"></span>
    </div>
    <div class="input-group-append"><button [disabled]="!queryString" class="btn btn-outline-secondary" type="submit">Search</button></div>
  </div>
</form>
